import { ideaStepFluxUpdateConstants } from '../constants';
import { ideaStepFluxService } from '../services';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const ideaStepFluxUpdateActions = {
  editIdeaStepFlux,
  setEditIdeaStepFluxAssociationsState,
  setNewContent,
}

function editIdeaStepFlux(ideaStepFlux) {

  return async dispatch => {
    dispatch({ type: ideaStepFluxUpdateConstants.EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_REQUEST });

    try {
      await ideaStepFluxService.editIdeaStepFlux(ideaStepFlux);
      dispatch({ type: ideaStepFluxUpdateConstants.EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_SUCCESS });
      dispatch(alertActions.success('Etapa alterada com sucesso!'));
      history.push('/preferences/flux-of-ideas');
    } catch(error) {

      dispatch({
        type: ideaStepFluxUpdateConstants.EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_FAILURE,
        error: error.toString()
      });
      dispatch(alertActions.error('tente novamente'));
    }
  }
}

function setNewContent({ name, value }) {
  return (dispatch) => {
    dispatch({ type: ideaStepFluxUpdateConstants.SET_NEW_CONTENT_FLUX, payload: { name, value } });
  }
}

function setEditIdeaStepFluxAssociationsState({ _id, nextStepWhenApproved, nextStepWhenRejected }) {
  return async dispatch => {
    dispatch({ type: ideaStepFluxUpdateConstants.SET_EDIT_IDEA_STEP_FLUX_ASSOCIATIONS_STATE, payload: { _id, nextStepWhenApproved, nextStepWhenRejected } })
  }
}